{
  "pt": {
    "todo_group": {
      "actions": {
        "create": "Tarefa",
        "update": "Editar tarefa"
      },
      "attributes": {
        "category": "Categoria",
        "created_at": "Criado em",
        "description": "Descrição",
        "title": "Título",
        "todos_count": "Tarefas",
        "units": "Unidades"
      },
      "categories": {
        "confirmation": "Confirmação",
        "upload": "Carregamento"
      },
      "labels": {
        "no_groups": "Ainda não há tarefas para este projeto.",
        "required": "Este campo é obrigatório"
      },
      "toasts": {
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "update": "Tarefa atualizada"
      }
    }
  }
}
